export default __webpack_public_path__ + "static/media/profile.4e5e96dd.svg";